import { Box, FormSearchSelection } from '@shared/components';

import { type LearningObjectiveStatementFieldSlotProps } from '../qconfig-single-question-conditions-form-fields/type';

export interface SingleQuestionLOSSelectorProps {
  group: LearningObjectiveStatementFieldSlotProps;
}

export default function SingleQuestionLOSSelector(props: Readonly<SingleQuestionLOSSelectorProps>) {
  const { group } = props;

  return (
    <Box
      sx={(theme) => ({
        backgroundColor: theme.palette.grey[50],
        borderRadius: theme.shape.rounded(2),
        border: `1px solid ${theme.palette.grey[200]}`,
        p: theme.spacing(4),
      })}
    >
      <FormSearchSelection
        name='los'
        required
        label='เลือก LOS'
        options={group.hasViewPermission ? group.options : []}
        placeholder='เลือก LOS'
        noOptionsText={group.noOptionsText}
        loading={group.loading}
        getOptionDisabled={(option) =>
          option === null ||
          (typeof option.value === 'string' && (group.existingLOS ?? []).includes(option.value))
        }
      />
    </Box>
  );
}
